import React, { useState } from "react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { Box, Modal, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "../styles/profile.scss";
import "../styles/popup.scss";
import { generateAiTest } from "../helper/apicalls/test";
import GlobalLoader from "./GlobalLoader";

const AiGenerationPopup = ({
  isOpen,
  onClose,
  onGenerate,
  pageKey,
  field,
  questions = [],
}) => {
  const [difficulty, setDifficulty] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleGenerate = async () => {
    if (difficulty) {
      setLoading(true);
      try {
        const token = Cookies.get("accessToken");

        const prevQuestion = questions
          .map((q) => {
            if (typeof q === "string") return q;
            if (q.question) return q.question;
            if (
              q.content &&
              typeof q.content === "object" &&
              q.content.question
            )
              return q.content.question;
            if (q.content && typeof q.content === "string") {
              try {
                const parsed = JSON.parse(q.content);
                return parsed.question || "";
              } catch (e) {
                return "";
              }
            }
            return "";
          })
          .filter((q) => q);

        const payload = {
          type: "test",
          field: field || "subtopic",
          level: difficulty.toLowerCase(),
          key: pageKey,
          prevQuestion: prevQuestion,
          token: token,
        };

        const result = await generateAiTest(payload);

        let generatedContent = [];

        if (result.content) {
          generatedContent = result.content;
        } else if (result.content) {
          generatedContent = result.content;
        } else if (result.content) {
          try {
            const parsed =
              typeof result.content === "string"
                ? JSON.parse(result.content)
                : result.content;
            generatedContent = parsed.content || [];
          } catch (e) {
            console.error("Failed to parse content:", e);
          }
        }

        if (generatedContent.length > 0) {
          const transformedQuestions = generatedContent.map((item, index) => {
            if (
              item.content &&
              typeof item.content === "object" &&
              item.content.question
            ) {
              return {
                ...item,
                sequence: item.sequence || index + 1,
                content: {
                  questions: [item.content],
                },
              };
            } else if (item.content && typeof item.content === "string") {
              try {
                const parsedContent = JSON.parse(item.content);
                return {
                  ...item,
                  sequence: item.sequence || index + 1,
                  content: {
                    questions: [parsedContent],
                  },
                };
              } catch (e) {
                return item;
              }
            }
            return {
              ...item,
              sequence: item.sequence || index + 1,
              content: {
                questions: [item.content || item],
              },
            };
          });

          const testId = `ai_generated_${Date.now()}`;

          const queryParams = new URLSearchParams({
            ai_test_id: testId,
            key: pageKey,
            title: field || "AI Generated Test",
            difficulty: difficulty.toLowerCase(),
          }).toString();

          navigate(`/test?${queryParams}`);

          onGenerate(difficulty, generatedContent);
        } else {
          console.error("No content generated");
        }
      } catch (error) {
        console.error("Failed to generate test:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleClose = () => {
    setDifficulty("");
    onClose();
  };

  const difficulties = ["Easy", "Medium", "Hard"];

  return (
    <>
      {loading && <GlobalLoader />}
      <Modal
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="ai-generation-modal-title"
        aria-describedby="ai-generation-modal-description"
        className="common-popup-overlay"
      >
        <Box className="common-popup-container">
          <Box className="popup-header">
            <div className="popup-title-box">
              <div id="ai-generation-modal-title" className="popup-title">
                Generate more Questions
              </div>
              <div className="popup-subtitle">
                Select the difficulty level for the AI-generated test
              </div>
            </div>
            <IconButton onClick={handleClose} className="popup-close-btn">
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>

          <Box className="popup-content">
            <Box
              sx={{ display: "flex", flexDirection: "column", gap: 3 }}
              className="popup-form-group"
            >
              <Box sx={{ display: "flex", gap: 2, justifyContent: "center" }}>
                {difficulties.map((level) => (
                  <button
                    key={level}
                    onClick={() => setDifficulty(level)}
                    disabled={loading}
                    style={{
                      padding: "10px 20px",
                      borderRadius: "8px",
                      border: `2px solid ${
                        difficulty === level
                          ? "var(--color-primary)"
                          : "#e0e0e0"
                      }`,
                      backgroundColor:
                        difficulty === level
                          ? "var(--color-primary-light)"
                          : "white",
                      color:
                        difficulty === level
                          ? "var(--color-primary)"
                          : "var(--text-primary)",
                      cursor: loading ? "not-allowed" : "pointer",
                      fontWeight: 600,
                      flex: 1,
                      transition: "all 0.2s",
                      opacity: loading ? 0.6 : 1,
                    }}
                  >
                    {level}
                  </button>
                ))}
              </Box>
            </Box>
          </Box>

          <Box className="popup-actions">
            <button
              className="btn-primary"
              onClick={handleGenerate}
              disabled={loading || !difficulty}
              style={{
                minWidth: 120,
                padding: "10px 24px",
                fontSize: "16px",
                opacity: loading || !difficulty ? 0.6 : 1,
                cursor: loading || !difficulty ? "not-allowed" : "pointer",
              }}
            >
              {loading ? "Generating..." : "Generate"}
            </button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default AiGenerationPopup;
